export const DEFAULT_PLACEHOLDER = "PLACEHOLDER_VALUE"